<template>
  <el-row type="flex" justify="center" class="fiat-select">
    <el-select v-model="fiat_value" :disabled="isDisabled" :popper-append-to-body="false" popper-class="fiat-select-down" :clearValue="clearValue"
               @visible-change='clearDrop($event)' @change="changeFait">
      <template slot="prefix" v-if="activeUrl">
        <img class="value-icon" :src="activeUrl" alt/>
      </template>
      <div class="fiat-select-search-input">
        <el-input ref="input1" size="mini" :placeholder="$t('400071')" v-model="dropDownValue" clearable>
          <i slot="prefix" class="iconfont icon-sousuo"></i>
        </el-input>
      </div>
      <div slot="empty" class="fiat-select-search-input" >
        <el-input ref="input2" :placeholder="$t('400071')" size="mini" v-model="dropDownValue" clearable>
          <i slot="prefix" class="iconfont icon-sousuo"></i>
        </el-input>
        <p style="text-align: center; font-size: 14px;margin: 16px">{{$t('400025')}}</p>
      </div>
      <!--所有法币-->
<!--      <el-option value="" :label="$t('400083')"></el-option>-->
      <el-option class="fiat-wrapper flex-center" :value="f.value | upcase" v-for="f in fiat" :key="f.key">
        <img class="countryIcon" v-show="f.extra" :src="f.extra" alt/>{{f.value | upcase}}
      </el-option>
    </el-select>
  </el-row>
</template>
<script>
import {getEnumList} from "@/apis/C2C";

export default {
  props: {
    value: String,
    optionsFilter: {
      type: Function,
      default: (v) => true,
    },
    clearValue: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    fiatAll: {
      type: Array,
      default: []
    },
    activeUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultValue: '',
      dropDownValue: ''
    }
  },
  computed: {
    fiat_value: {
      get() {
        return this.value || this.defaultValue
      },
      set(v) {
        this.defaultValue = v
        this.$emit('input', v)
        this.$emit('change', v)
      }
    },
    fiat() {
      if (!this.dropDownValue) {
        return this.fiatAll
      }else {
        return this.fiatAll.filter((p)=>{//返回过滤后的数组
          return p.value.indexOf(this.dropDownValue.toLowerCase()) !== -1
        })//filter是过滤函数去除了不包含关键字的情况
      }
    }
  },
  watch:{
    fiat:{
      'handler': function(newVal,oldVal) {
        if(newVal.length > 0){
          this.$nextTick(() => {
            this.$refs.input1.focus()
          });
        }else{
          // console.log(this.$refs.input1);
          this.$nextTick(() => {
            this.$refs.input2.focus()
          });
        }
      }
    }
  },
  created() {
    /*getEnumList({type: 'fiat'}).then(res => {
      this.fiatAll = res.data.fiat || []
      this.activeUrl = res.data.fiat.find(v => v.value == this.fiat_value.toLowerCase()) ? res.data.fiat.find(v => v.value == this.fiat_value.toLowerCase()).extra : ''
    })*/
  },
  methods: {
    clearDrop($event) { //此处的clearDrop用于解决搜索内容不存在时，所有内容无法显示的bug
      if ($event) {
        this.dropDownValue = ''
      }
    },
    changeFait() {
      if (this.defaultValue) {
        this.$parent.activeUrl = this.fiatAll.find(v => v.value == this.defaultValue.toLowerCase()).extra
      }else {
        this.$parent.activeUrl = ''
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.fiat-select{
  .el-input__prefix{
    line-height: 44px;
    @include font_color('font-color-1');
    img{
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-left: 6px;
    }
  }
}
.fiat-select-down {
  //z-index: 99 !important;
  transform:translateX(-5px);
  .el-select-dropdown__item{
    text-overflow: initial;
  }
  .fiat-select-search-input {
    width: 85%;
    margin: 12px 0 12px 0px;
    // margin-left: 13px;
    .el-input__inner {
      height: 40px;
      line-height: 40px;
      font-size: $font-size-small;
      @include font_color('font-color');
    }

    // .fiat-wrapper {
    //   img {
    //     margin-right: 8px;
    //     width: 16px;
    //     height: 16px;
    //   }
    // }
  }
}
.countryIcon{
  width: 16px;
  height: 16px;
  border-radius: 50%;
  // margin-right: 8px
}
</style>
<style lang="scss">
[dir = 'ltr'] .countryIcon{
  margin-right: 8px
}
[dir = 'rtl'] .countryIcon{
  margin-left: 8px
}

[dir = 'ltr'] .fiat-select-down {
  .fiat-select-search-input {
    margin-left: 13px;
  }
}
[dir = 'rtl'] .fiat-select-down {
  .fiat-select-search-input {
    margin-right: 13px;
  }
}
</style>